import {SearchTermsEnum} from 'presentation/constants/searchTermsEnum';
import {termsBySearch} from 'presentation/constants/termsBySearch';
import {FlowEnum} from 'presentation/pages/private/booking/constants';
import {GetSpecialtyBySearchProps} from './types';

function getSpecialtyBySearch({text, flowType}: GetSpecialtyBySearchProps) {
	const normalizedText = text.toLowerCase();

	const listTerms = Object.keys(termsBySearch).filter(term => {
		if (flowType === FlowEnum.HEALTH) {
			return term === SearchTermsEnum.DOR_DE_CABECA;
		}

		if (flowType === FlowEnum.EXAM) {
			return term !== SearchTermsEnum.DOR_DE_CABECA;
		}

		return true;
	});

	let result = '';
	listTerms.forEach(key => {
		const terms = termsBySearch[key as SearchTermsEnum];

		if (result.length > 0) {
			return;
		}
		if (terms.some(term => normalizedText.includes(term.toLocaleLowerCase()))) {
			result = key as SearchTermsEnum;
		}
	});

	if (result.length <= 0) {
		result = text;
	}

	return result.toLocaleLowerCase();
}

export {getSpecialtyBySearch};
